var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVehiclesPlaceholder = function SvgVehiclesPlaceholder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1040 -397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    transform: "translate(1040 397)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1056.917 414)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 53,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-16419.365-19339.924c-6.027,6.973-4.678,25.672-4.678,25.672s21.1,10.449,23.721,25.49c0,0,13.275,3.367,22.434.076,0,0,5.264-19.7,23.783-25.566,0,0,2.384-14.035-4.5-25.672C-16389.029-19347.393-16419.365-19339.924-16419.365-19339.924Z",
    transform: "translate(17504 19794)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1102 460)",
    fill: "#dbdbdb",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-16429.4-19334.365c-3.469,6.775-3.973,16.66-3.256,22.793a14.208,14.208,0,0,1,5.732,1.412c-1.363-17.377,4.02-25.092,4.02-25.092Z",
    transform: "translate(17503 19789.068)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16426.258-19333.57c3.469,6.885,3.836,16.344,3.117,22.576a19.454,19.454,0,0,0-6.184,1.4c1.363-17.656-4.088-25.635-4.088-25.635Z",
    transform: "translate(17582.988 19789.07)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16400.48-19285.863s12.18,3.307,23.235,0a44.208,44.208,0,0,0-1.565,7.6s-7.7,2.844-20.143,0C-16399.453-19281.687-16400.48-19285.863-16400.48-19285.863Z",
    transform: "translate(17503.779 19794.5)",
    fill: "#dbdbdb"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVehiclesPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vehicles_placeholder.5da2e333fd6b201c0d9528d31d0b89c0.svg";